import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import AppBar from '@pray/shared/components/ui/AppBar';
import Button from '@pray/shared/components/ui/Button';
import type { Plan, RecurringPeriod } from '@pray/shared/data/pricing/types';
import { cn } from '@pray/shared/utils/styles';

import { VIEW_EVENT_NAMES } from 'constants.js';
import { additionalIdentifyUser } from 'utils/analytics/hubspot/tracking';

import Pricing from '../../pricing/components/Pricing';
import { HUBSPOT_STEP_VIEW_EVENT_NAMES } from '../utils/constants';
import { hubspotTrackStepView } from '../utils/step-tracking';

import styles from './PricingPaywallOnboardingStep.scss';

export default function PricingPaywallOnboardingStep(props) {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get('product_id');
  const interval = searchParams.get('interval');
  const hasCheckoutInfo = productId && interval;

  useEffect(() => {
    if (hasCheckoutInfo) props.onContinue();
  }, [hasCheckoutInfo]);

  return !hasCheckoutInfo ? <PricingPawyallStep {...props} /> : null;
}

function PricingPawyallStep(props) {
  const { hasLogo, hasAppBar, showBackButton, showSkipButton, logo, onBack, onContinue } = props;
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    hubspotTrackStepView(HUBSPOT_STEP_VIEW_EVENT_NAMES.PRICING_PAYWALL);
  }, []);

  const handlePlanSelect = (plan: Plan, recurringPeriod: RecurringPeriod) => {
    const product = plan.pricing[recurringPeriod];

    setSearchParams({
      product_id: product.id,
      interval: recurringPeriod,
    });

    additionalIdentifyUser({
      plan_name: plan.name,
      recurring__monthly_or_yearly_: recurringPeriod,
      price: plan.pricing[recurringPeriod].price.toString(),
    });

    onContinue();
  };

  const skipButton = (
    <Button onClick={() => onContinue({ isSkipped: true })} style={{ paddingRight: 0 }}>
      Skip
    </Button>
  );

  return (
    <div data-viewname={VIEW_EVENT_NAMES.ONBOARDING_FLOW.PRICING_PAYWALL_STEP}>
      {hasAppBar && (
        <AppBar center={hasLogo && logo} right={showSkipButton && skipButton} onBack={showBackButton && onBack} />
      )}
      <div className={cn(styles.container, hasAppBar ? styles.hasAppBar : '')}>
        <div className="py-4 md:py-8">
          <Pricing onPlanSelect={handlePlanSelect} showSolutionsSection={false} />
        </div>
      </div>
    </div>
  );
}
